module.exports = __webpack_public_path__ + "static/img/11笔筒.5cc2215.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/模型库/11笔筒.png
// module id = KQG0
// module chunks = 1